export const formatFunc = (str: string, data: Record<string, unknown>): string => {
  const re = /{([^{}]+)}/g;

  return str.replace(re, (match, val) => {
    let prop: unknown = data;
    // @ts-ignore
    val.split('.').forEach((key) => {
      // @ts-ignore
      prop = prop[key];
    });

    return prop as string;
  });
};
